export default "__VITE_ASSET__CWX8n_OZ__"